<!--退出登录弹框-->
<template>
  <div class="logout-container">
    <van-dialog
      v-model="logoutShow"
      :title="content.noauthTip"
      :show-cancel-button="!isPc"
      :show-confirm-button="!isPc"
      :confirmButtonColor="'#2A8AFA'"
      :confirmButtonText="content.besure"
      :cancelButtonText="content.becancel"
      :width="isPc?'6.36rem':'3.36rem'"
      @confirm="logoutConfirm"
      @cancel="closeDialog"
    >
      <div :class="[isPc ? 'pc-logout-content' : 'phone-logout-content']">{{ content.logoutDesc }}</div>
      <div v-if="isPc" class="pc-logout-btns">
        <van-button
          type="default"
          class="cancel-btn"
          size="small"
          @click="closeDialog"
        >{{content.becancel}}</van-button>
        <van-button
          type="info"
          class="sure-btn"
          size="small"
          color="2A8AFA"
          @click="logoutConfirm"
        >{{content.besure}}</van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      logoutShow: false,
    }
  },
  computed: {
    content() {
      return this.$store.state.content
    },
    ...mapState(['isPc'])
  },
  methods: {
    showDialog() {
      this.logoutShow = true
    },
    closeDialog() {
      this.logoutShow = false
    },
    logoutConfirm() {
      this.logoutShow = false
      this.$emit('logout')
    }
  }
}
</script>

<style lang="less" scoped>
div {
  box-sizing: border-box;
}
.van-dialog {
  border-radius: 6px;
}
.logout-container{
  .pc-logout-content{
    text-align: center;
    padding: 0.5rem;
  }
  .phone-logout-content{
    text-align: center;
    padding: 0.2rem 0;
  }
  .pc-logout-btns{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 0.3rem;
    .cancel-btn{
      width: 0.9rem;
      &:hover{
        opacity: 0.9;
      }
    }
    .sure-btn{
      margin-left: 0.3rem;
      width: 0.9rem;
      &:hover{
        opacity: 0.9;
      }
    }
  }
}
</style>